<template>
  <main>
    <NewNavBar />
    <div class="content" :style="{ padding: paddingValue }">
      <slot> </slot>
    </div>
  </main>
</template>

<script>
import NavBar from "./Modules/NavBar.vue";
import Main from "./Modules/Main.vue";
import NewNavBar from "./Modules/NewNavBar.vue";
export default {
  components: { Main, NavBar, NewNavBar },
  computed: {
    paddingValue() {
      return this.$store.getters.getPadding;
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

body {
  overflow-x: hidden;
 
  background: white!important;
}

.sc  {
  overflow-y: hidden;
}

a {
  text-decoration: none;
}
.content {
  width: 100%;
  height: 100%;
  margin-left: 0;
}

@media (max-width: 425px) {
  .content {
    padding: 0;
  }
}
</style>
